import { useState } from "react";
import { api } from "../api/client";
import { usePatchMe } from "../api/hooks";
import { useT } from "../i18n";
import { setPrefs } from "../lib/prefs";

/** §6.3: the three-button question before placement. */
export function Seed({ onDone }: { onDone: () => void }) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const patchMe = usePatchMe();
  async function pick(level: "new" | "club" | "strong") {
    setBusy(true);
    try {
      await api("/me/placement", { body: { level } });
      // move-input-spec §1: new players start with beginner input
      const move_assist = level === "new" ? "beginner" : "advanced";
      setPrefs({ move_assist });
      patchMe.mutate({ settings: { move_assist } });
      onDone();
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="card stack" style={{ textAlign: "center", padding: 28 }}>
      <h1>{t("seed.title")}</h1>
      <p className="muted">{t("seed.lead")}</p>
      <div className="stack" style={{ maxWidth: 320, margin: "8px auto 0", width: "100%" }}>
        <button className="big" disabled={busy} onClick={() => pick("new")}>{t("seed.new")}</button>
        <button className="big primary" disabled={busy} onClick={() => pick("club")}>{t("seed.club")}</button>
        <button className="big" disabled={busy} onClick={() => pick("strong")}>{t("seed.strong")}</button>
      </div>
    </div>
  );
}
